import { action, computed, makeObservable, observable, toJS } from 'mobx';

import CutshapePatent from './CutshapePatent';

export enum CutShapeId {
  Round = 2,
  Princess = 4,
  Cushion = 9,
  Oval = 11,
  Marquise = 80,
  Pear = 22,
  Radiant = 83,
  Emerald = 90,
  Heart = 85,
  Cube = 204,
  Other = 113,
  Cuboid = 'cuboid',
}

export const SHAPE_ROUND: CutShapeId.Round = CutShapeId.Round;
export const SHAPE_PRINCESS: CutShapeId.Princess = CutShapeId.Princess;
export const SHAPE_CUSHION: CutShapeId.Cushion = CutShapeId.Cushion;
export const SHAPE_OVAL: CutShapeId.Oval = CutShapeId.Oval;
export const SHAPE_MARQUISE: CutShapeId.Marquise = CutShapeId.Marquise;
export const SHAPE_PEAR: CutShapeId.Pear = CutShapeId.Pear;
export const SHAPE_RADIANT: CutShapeId.Radiant = CutShapeId.Radiant;
export const SHAPE_EMERALD: CutShapeId.Emerald = CutShapeId.Emerald;
export const SHAPE_HEART: CutShapeId.Heart = CutShapeId.Heart;
export const SHAPE_CUBE: CutShapeId.Cube = CutShapeId.Cube;
export const SHAPE_OTHER: CutShapeId.Other = CutShapeId.Other;
export const SHAPE_CUBOID: CutShapeId.Cuboid = CutShapeId.Cuboid; // we don't have such cut shape in system

export const MAIN_SHAPES_IDS: CutShapeId[] = [
  CutShapeId.Round,
  CutShapeId.Princess,
  CutShapeId.Cushion,
  CutShapeId.Oval,
  CutShapeId.Marquise,
  CutShapeId.Pear,
  CutShapeId.Radiant,
  CutShapeId.Emerald,
  CutShapeId.Heart,
  CutShapeId.Other,
];

export class CutShapeModel {
  id!: number;
  title!: string;
  cutShapePatents!: CutshapePatent[];
  isPatented!: boolean;
  parent!: Nullable<CutShapeModel>;
}

export default class CutShape extends CutShapeModel {
  title: string = '';

  parent: Nullable<CutShape> = null;

  cutShapePatents: CutshapePatent[] = [];

  isPatented = false;

  get rootShapeId() {
    return this.parent?.id ?? this.id;
  }

  constructor(modelData: CutShapeModel) {
    super();

    makeObservable(this, {
      toDto: false,
      title: observable,
      parent: observable,
      cutShapePatents: observable,
      isPatented: observable,
      rootShapeId: computed,
      addEmptyPatent: action,
      removePatentByIndex: action,
    });

    Object.assign(this, modelData);
  }

  addEmptyPatent = () => {
    this.cutShapePatents.push(new CutshapePatent());
  };

  removePatentByIndex(index: number) {
    this.cutShapePatents.splice(index, 1);
  }

  toDto() {
    return toJS({
      ...this,
      parent: this.parent?.id,
    });
  }
}
